import React, { forwardRef } from "react";
import "./H2.scss";

const H3 = forwardRef((props, ref) => {
  const { text, style } = props;

  return (
    <h2 style={style} className={'h2_subtitle'}>
      {text}
    </h2>
  );
});

export default H3;
